import { render, staticRenderFns } from "./Ordenesservicios.vue?vue&type=template&id=cb8ce0e2"
import script from "./Ordenesservicios.vue?vue&type=script&lang=js"
export * from "./Ordenesservicios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports